import {
  VALIDAMOBILE_SUCCESS,
  VALIDAMOBILE_LOADING,
  VALIDAMOBILE_ERROR,
  VALIDAMOBILE_LOGOUT,
} from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "global/helpers/axiosLogin";

export const validaMobile = (event) => (dispatch) => {
  dispatch({
    type: VALIDAMOBILE_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get("/shared/registro/verificar-mobile/" + event)
      .then((res) => {
        dispatch({
          type: VALIDAMOBILE_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
        };

        dispatch({
          type: VALIDAMOBILE_ERROR,
          payload: error,
        });
      });
  });
};
// export const validaMobile = (event) => (dispatch) => {
//   dispatch({
//     type: VALIDAMOBILE_LOADING,
//   });
//   axiosInstance().then((respuesta) => {
//     respuesta
//       .get("/registro/verificarMobile/" + event)
//       .then((res) => {
//         dispatch({
//           type: VALIDAMOBILE_SUCCESS,
//           payload: res.data,
//         });
//       })
//       .catch((err) => {
//         let error = {
//           detail: err.response
//             ? err.response.data
//             : "Error al contactar el server.",
//         };

//         dispatch({
//           type: VALIDAMOBILE_ERROR,
//           payload: error,
//         });
//       });
//   });
// };

export const logoutValidaMobile = () => (dispatch) => {
  dispatch({ type: VALIDAMOBILE_LOGOUT });
};
